export const ENTITY_TYPES = {
  lootbox: 'lootbox',
};

export type EntityType = typeof ENTITY_TYPES[keyof typeof ENTITY_TYPES];
